import React from "react";
import { content, teamMembers } from "../content/team.content";
import { FaLinkedin } from 'react-icons/fa';

const TeamBios = () => {
  return (
    <section
      id="team"
      className="bg-secondary text-primary py-16 min-h-screen"
    >

      <div className="container mx-auto px-6">
        {/* Section Heading */}
        <h2 className="text-4xl font-bold text-center mb-8">{content.name}</h2>

        {/* Introduction */}
        <p className="text-center text-lg leading-relaxed max-w-3xl mx-auto mb-12">
          {content.description}
        </p>

        {/* Team Member Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers
            .filter(member => member.status === 1)
            .map((member, index) => (
              <div
                key={index}
                className="bg-primary text-secondary p-6 rounded shadow-lg hover:shadow-xl transition text-center"
              >
                {/* Team Member Image */}
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 rounded-full object-cover mx-auto mb-4"
                />

                {/* Team Member Info */}
                <div className="flex items-center justify-center gap-2 mb-2">
                  <h3 className="text-xl font-bold">{member.name}</h3>
                  <a
                    href={member.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center text-secondary"
                    aria-label={`Visit ${member.name}'s LinkedIn profile`}
                  >
                    <FaLinkedin size={20} />
                  </a>
                </div>
                
                <p className="text-sm italic mb-4">{member.role}</p>
                <p className="text-sm">{member.bio}</p>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default TeamBios;
